import { Box, Button } from '@factorialco/deprecated-design-system'
import {
  FindWorkflowDocument,
  ProcurementTypeItemFragment,
  RequestTypeDetailDocument,
  VersioningProcurementTypeDocument,
} from 'generated/resources/graphql'

import Modal from 'modules/core/components/Modal'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import { Form } from 'modules/forms/lib/Form'

interface Props {
  procurementType: ProcurementTypeItemFragment
  form: Form | undefined
  onClose: () => void
}
const VersioningRequestTypeModal = ({ procurementType, form, onClose }: Props) => {
  const { company, employee } = useCurrentSession()
  const [versioningForm, { loading }] = useMutation(VersioningProcurementTypeDocument, {
    extractorFn: (data) => data.procurementMutations.versioningProcurementType,
    refetchQueries: [RequestTypeDetailDocument, FindWorkflowDocument],
  })

  const onPublishProcurementType = async () => {
    if (!form || !employee) return

    const result = await versioningForm({
      variables: {
        id: procurementType.id.toString(),
        formId: form.id,
        authorId: employee.id,
        companyId: company.id,
      },
    })

    const handled = handleResult(result, () =>
      app.setFlash({
        type: 'wrong',
        message: i18n.t('errors.generic_error'),
      })
    )

    if (handled.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('procurement.types.forms.edit_form_message'),
      })
    }
    handleClose()
  }

  const handleClose = () => {
    onClose()
  }

  return (
    <Modal
      illustration="input-field"
      title={i18n.t('procurement.purchase_requests.settings.types.modals.versioning.title')}
      description={i18n.t(
        'procurement.purchase_requests.settings.types.modals.versioning.description',
        {
          name: procurementType.name,
        }
      )}
      footer={
        <>
          <Button type="secondary" onClick={handleClose}>
            {i18n.t('common.cancel')}
          </Button>
          <Button onClick={onPublishProcurementType} disabled={loading}>
            {i18n.t('procurement.purchase_requests.settings.types.modals.versioning.buttons.edit')}
          </Button>
        </>
      }
      onClose={onClose}
    >
      <Box gap="s16"></Box>
    </Modal>
  )
}

export default VersioningRequestTypeModal
